export default __webpack_public_path__ + "static/2-996f8bbb70409e61b093cb70ec4371e8.jpg";